import { Box, Container, Grid, Link, Tooltip, Typography } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import TipsAndUpdatesIcon from "@mui/icons-material/TipsAndUpdates";

const Logs = () => {
  return (
    <Container className="container-xxl my-4">
      <Box className="card p-4">
        <Grid container className="mb-4">
          <Grid item xs={12} className="d-flex align-items-center">
            <Typography className="fw-normal mb-4">
              Transaction Receipt Event Logs
            </Typography>
          </Grid>
        </Grid>

        <Box className="d-flex">
          <Box className="mt-1 me-3">
            <span
              className="bg-success bg-opacity-10 no-border text-success fs-70x content-center rounded-pill mx-auto"
              style={{ width: "2.8rem", height: "2.8rem" }}
            >
              449
            </span>
          </Box>

          <Box className="flex-grow-1 flex-shrink-1">
            <Grid container className="row align-items-baseline mb-3">
              <Grid
                item
                md={2}
                lg={1}
                className="col-md-2 col-lg-1 text-md-end"
              >
                <Typography className="fw-bold mb-0">Address</Typography>
              </Grid>
              <Grid md={10} lg={11} item className="col-md-10 mb-0">
                <Link
                  className="text-break d-inline-flex me-1"
                  href="/address/0x388c818ca8b9251b393131c08a736a67ccb19297"
                >
                  <span
                    className="hash-tag hash-tag-lg text-truncate"
                    data-bs-toggle="tooltip"
                    data-bs-title="Lido: Execution Layer Rewards Vault (0x388c818ca8b9251b393131c08a736a67ccb19297)"
                  >
                    Lido: Execution Layer Rewards Vault
                  </span>
                </Link>
                <Link className="js-clipboard link-secondary ">
                  <ContentCopyIcon
                    className="text-icon"
                    onClick={() => navigator.clipboard.writeText("")}
                  />
                </Link>

                <AddCircleOutlineIcon className="text-icon text-dt" />
              </Grid>
            </Grid>

            <Grid container className="row align-items-baseline mb-3">
              <Grid
                item
                md={2}
                lg={1}
                className="col-md-2 col-lg-1 text-md-end"
              >
                <Typography className="mb-0 text-muted">Name</Typography>
              </Grid>
              <Grid md={10} lg={11} item className="col-md-10 mb-0">
                <Box className="d-flex gap-1">
                  <Tooltip
                    describeChild
                    title="Lido: Execution Layer Rewards Vault (0x388c818ca8b9251b393131c08a736a67ccb19297)"
                    placement="top"
                  >
                    <Typography className="hash-tag hash-tag-lg text-truncate">
                      UPCReceived
                    </Typography>
                  </Tooltip>
                  (<span className="text-success">uint256</span>
                  <span className="text-danger">amount</span>)
                  <Link>View Source</Link>
                </Box>
              </Grid>
            </Grid>

            <Grid container className="row align-items-baseline mb-3">
              <Grid
                item
                md={2}
                lg={1}
                className="col-md-2 col-lg-1 text-md-end"
              >
                <Typography className="mb-0 text-muted">Topics</Typography>
              </Grid>
              <Grid md={10} lg={11} item className="col-md-10 mb-0">
                <Box className="d-flex gap-1">
                  <span className="badge bg-secondary bg-opacity-10 border border-secondary border-opacity-25 text-dark fw-medium text-start text-wrap py-1.5 px-2 me-1">
                    0
                  </span>
                  <span className="font-monospace text-break">
                    0x27f12abfe35860a9a927b465bb3d4a9c23c8428174b83f278fe45ed7b4da2662
                  </span>
                </Box>
              </Grid>
            </Grid>

            <Grid container className="row align-items-baseline mb-3">
              <Grid
                item
                md={2}
                lg={1}
                className="col-md-2 col-lg-1 text-md-end"
              >
                <Typography className="mb-0 text-muted">Data</Typography>
              </Grid>
              <Grid md={10} lg={11} item className="col-md-10 mb-0">
                <Box className="list-unstyled bg-light rounded p-3 mb-2 d-md-flex justify-content-between">
                  <div id="event_dec_data_1">
                    <li className="d-lg-flex">
                      <span className="text-muted rounded me-1 text-truncate">
                        amount :
                      </span>
                      <span
                        className="font-monospace text-break d-block d-sm-inline-block"
                        data-bs-toggle="tooltip"
                      >
                        292355622012614749
                      </span>
                    </li>
                  </div>
                  <div className="d-flex align-items-start mt-3 mt-md-0 ms-md-3">
                    {" "}
                    <div className="btn-group" role="group">
                      <input
                        type="radio"
                        className="btn-check"
                        name="options_1"
                        id="option1_1"
                      />{" "}
                      <label className="btn btn-sm btn-secondary"> Dec </label>{" "}
                      <input
                        type="radio"
                        className="btn-check"
                        name="options_1"
                        id="option2_1"
                      />{" "}
                      <label className="btn btn-sm btn-secondary"> Hex</label>{" "}
                    </div>{" "}
                  </div>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Box>

      <Box className="mt-4">
        <p className="d-flex align-items-baseline fs-sm text-muted gap-1 mb-3">
          <TipsAndUpdatesIcon className="small-icon" />
          <span>
            A transaction is a cryptographically signed instruction that changes
            the blockchain state. Block explorers track the details of all
            transactions in the network. Learn more about transactions in our{" "}
            <Link target="_blank" href="/knowledge">
              Knowledge Base
            </Link>
            .
          </span>
        </p>
      </Box>
    </Container>
  );
};

export default Logs;
